import { styled } from "@mui/material/styles";
import TreeItem, { treeItemClasses, TreeItemProps } from "@mui/lab/TreeItem";
import { cyan } from "@mui/material/colors";

export const StyledMuiTreeItem = styled(TreeItem, { shouldForwardProp: prop => prop !== "isSelected" })<
  TreeItemProps & { isSelected?: boolean }
>(({ isSelected }) => ({
  [`& .${treeItemClasses.iconContainer}`]: {
    "& .close": {
      opacity: 0.3,
    },
  },
  [`& > .${treeItemClasses.content}`]: {
    backgroundColor: isSelected ? cyan[300] : "transparent",
    [`&.${treeItemClasses.selected}`]: {
      backgroundColor: isSelected ? cyan[300] : "transparent",
    },
    [`&.${treeItemClasses.focused}`]: {
      backgroundColor: isSelected ? cyan[300] : "transparent",
    },
    [`&.${treeItemClasses.selected}.${treeItemClasses.focused}`]: {
      backgroundColor: isSelected ? cyan[300] : "transparent",
    },
    "&:hover": {
      backgroundColor: cyan[400],
    },
  },
  [`& .${treeItemClasses.group}`]: {
    marginLeft: 8,
    paddingLeft: 10,
    borderLeft: "1px solid rgba(54, 56, 70, 0.6)",
  },
}));
